import { render, staticRenderFns } from "./MonthlyTaxExportParam.vue?vue&type=template&id=a58bcac4"
import script from "./MonthlyTaxExportParam.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxExportParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports